import BigNumber from 'bignumber.js'
import { BIG_TEN } from 'utils/bigNumber'
import { parseEther } from "@ethersproject/units";
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import getGasPrice from 'utils/getGasPrice'

const options = {
  // gasLimit: DEFAULT_GAS_LIMIT,
}

/*
string memory _name,
        string memory _symbol,
        uint256 _totalSupply,
        address[4] memory _addrs, // reward, router, marketing wallet, dividendTracker
        uint256[3] memory _feeSettings, // rewards, liquidity, marketing
        uint256 _minimumTokenBalanceForDividends,
        address _serviceFeeReceiver,
        uint256 _serviceFee
*/
export const createToken = async (factoryContract, params ) => {
  const gasPrice = getGasPrice()
  const { name, symbol, totalSupply, addressAry, feeSettings, minTokenBalanceForDividends, serviceFeeReceiver, serviceFee /* , implementation */ } = params
  console.log("[GD], createToken, tokenFactoryContract=", factoryContract)
  console.log("[GD], createToken, params=", params)
  const tSupply = parseEther(totalSupply) // new BigNumber(totalSupply).times(BIG_TEN.pow(18))
  console.log("[GD], createToken, tSupply=",tSupply)
  const tx = await factoryContract.createBabyToken(
  //  implementation,
    name,
    symbol,
    tSupply,
    addressAry,
    feeSettings, 
    minTokenBalanceForDividends, 
    serviceFeeReceiver, 
    serviceFee,
    {...options, gasPrice}
  )
  const receipt = await tx.wait()
  if(receipt.status) {
    const lastEvent = receipt.events[receipt.events.length - 1]
    if(lastEvent.event !== "BabyTokenCreated")
      return { status: false }
    const babyAddress = lastEvent.args.babyToken;
    console.log("[GD], createToken:babyAddress = ", babyAddress);
    return {
      status: true,
      babyToken: babyAddress
    }
  }
  return {
    status: false
  }
}